"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
var defaultTranslations = {
  gamblingSupport: "Gambling Support",
  contactSupport: "Contact Support",
  responsibleGambling: "Responsible Gambling",
  termsConditions: "Terms & Conditions",
  help: "Help",
  rules: "Game Rules",
  privacyAndCookies: "Privacy Policy"
};
exports.defaultTranslations = defaultTranslations;